const R = require('ramda');
const { differenceInDays, parseISO, startOfDay, parse, getDaysInMonth } = require('date-fns');
const { utcToZonedTime } = require('date-fns-tz');

function getDateTZ(d) {
  if (typeof d == 'string') {
    d = new Date(d);
  }
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
}

function getToday() {
  const d = new Date();
  return getDateTZ(d);
}

function uniq(array) {
  return Array.from(new Set(array));
}

/** Similar to Object.assign, but does not fail. */
function failProofAssign(target, source) {
  for (let key of Object.keys(source)) {
    try {
      target[key] = source[key];
    } catch (err) {}
  }
}

/**
 * Returns the intersection of ES6 Set objects. i.e., returns a new set with only elements contained in all the given sets.
 *
 * @param {Set|Array} set1 First set
 * @param {Set|Array} set2 First set
 * @returns {Set|Array} Intersection
 */
function getIntersection(set1, set2) {
  return R.intersection(set1, set2);
  return new Set([...set1].filter(x => set2.has(x)));
}

/**
 * Set the first letter to upper-case.
 * @param {string} s
 * @returns {string}
 */
function capitalize(s) {
  if (s === '') {
    return s;
  }
  return s[0].toUpperCase() + s.slice(1);
}

function getRemainingDays(dateFilterTo, timeZone = 'Asia/Seoul') {
  const utcNow = new Date();
  const now = startOfDay(utcToZonedTime(utcNow, timeZone));

  const to = parseISO(dateFilterTo);

  return to <= now ? 0 : differenceInDays(to, now);
}

function getTotalDurationInDays(dateFilterFrom, dateFilterTo) {
  const from = parseISO(dateFilterFrom);
  const to = parseISO(dateFilterTo);

  return differenceInDays(to, from) + 1;
}

function getNumberOfDaysPerRow(dateFilterFrom, dateFilterTo, timeZone = 'Asia/Seoul') {
  const utcNow = new Date();
  const now = startOfDay(utcToZonedTime(utcNow, timeZone));

  const from = parseISO(dateFilterFrom);
  const to = parseISO(dateFilterTo);

  return to > now ? differenceInDays(now, from) + 1 : differenceInDays(to, from) + 1;
}

function getNumberOfDaysInMonth(dateFilterTo) {
  const date = parse(dateFilterTo, 'yyyy-MM-dd', new Date());
  return getDaysInMonth(date);
}

module.exports = {
  getToday,
  uniq,
  failProofAssign,
  getIntersection,
  capitalize,
  getRemainingDays,
  getTotalDurationInDays,
  getNumberOfDaysPerRow,
  getNumberOfDaysInMonth,
};
